import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import {
  appModeUuid,
  appModeName,
  buildVersion,
  environment,
} from 'src/utils/capabilities';
import { getUri } from 'src/utils/getUri';

const baseConfig = {
  clientToken: 'pubbd1746a1cc2657d3181041a0dae7fcbe',
  site: 'us3.datadoghq.com',
  service: 'cw-agent-dashboard-frontend',
  env: environment,
  version: buildVersion,
};

export const initDatadog = () => {
  const apiUrl = `${window.config.baseUrl}${getUri()}`.replace(
    /([^:])(\/\/+)/g,
    '$1/',
  );

  const rumConfig = {
    ...baseConfig,
    applicationId: '1832be0a-6726-4498-bb45-3fd89a659309',
    sampleRate: 100,
    allowedTracingUrls: [apiUrl],

    // Session Replay
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    sessionSampleRate: 10,
    sessionReplaySampleRate: 10,

    // heatmap
    enableExperimentalFeatures: ['clickmap'],
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
  };

  const logsConfig = {
    ...baseConfig,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  };

  datadogRum.init(rumConfig);
  datadogRum.setGlobalContextProperty('application_mode_uuid', appModeUuid);
  datadogRum.setGlobalContextProperty('application_mode_name', appModeName);
  datadogRum.setGlobalContextProperty('release', buildVersion);
  datadogRum.setGlobalContextProperty('build_version', buildVersion);
  datadogRum.startSessionReplayRecording();

  datadogLogs.init(logsConfig);
  datadogLogs.setGlobalContextProperty('application_mode_uuid', appModeUuid);
  datadogLogs.setGlobalContextProperty('application_mode_name', appModeName);
  datadogLogs.setGlobalContextProperty('release', buildVersion);
  datadogLogs.setGlobalContextProperty('build_version', buildVersion);
};

export { datadogLogs };
